// Import all app colors
import colors from "common/config/colors.json";

// Define most popular colors by aliases. Reference base.scss theme
const aliases = {
    get text() {
        return this["text-primary"];
    },
    "text-primary": colors["gray-black"],
    "text-secondary": colors["gray-mid"], // Secondary text color where emphasize should be more on the primary
    
    "background-primary": colors["canvas-mid"],
    "background-secondary": colors["canvas-dark"],
    
    "corp-primary": colors.red,
    "corp-secondary": colors["green-mid"]
};

export const theme = {
    ...colors,
    ...aliases
};

export const getColorIfAlias = function(color) {
    if (Object.prototype.hasOwnProperty.call(theme, color)) {
        return theme[color].toUpperCase();
    }
    
    return void 0;
};
